import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotificationService } from './notification.service';
import { NotificationColor } from './notification.view-model';

@Component({
  selector: 'osn-cxb-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  providers: [{ provide: NotificationService }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  public vm$ = this.notificationService.vm$;
  public readonly NotificationColor = NotificationColor;

  constructor(private readonly notificationService: NotificationService) {}

  public onCancelClick(): void {
    this.notificationService.cancel();
  }
}
